/**
 * WHAT: Data deletion policy page bootstrap
 * WHY: Match other public pages (CONFIG + script.js); full-page backgrounds use page key `datadeletionpolicy` (Gallery admin tab)
 */

import CONFIG from './config/config.js';

window.CONFIG = {
    api: CONFIG.api,
    features: CONFIG.features
};
